export const MAX_LENGTH = 200;

export const reasonList = [{
    key: 1, 
    text: '抄袭作品'
},{
    key: 2, 
    text: '垃圾广告'
},{
    key: 3, 
    text: '人身攻击'
},{
    key: 4, 
    text: '违法违规'
},{
    key: 5, 
    text: '未成年人不宜'
}]

export const CONVENTION = 'https://icodeshequ.youdao.com/community_guide';
export const AGREEMENT = 'https://icode.youdao.com/tos';